/*
 *
 * NexiClubWaiverPopup
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 09-Jul-2025
*/

import NexiClubWaiverPopup from './NexiClubWaiverPopupContainer'

export default NexiClubWaiverPopup
